<app-header class="relative shadow-2">
    <router-outlet sidebar name="sidebar"></router-outlet>
</app-header>

<section class="flex-1 overflow-auto">
    <router-outlet></router-outlet>
</section>

@if (!isMobileApp()) {
    <app-tabs *appNgIfPhoneAndTablet="''; else footer" class="relative shadow-2"></app-tabs>
}

<ng-template #footer>
    <app-footer></app-footer>
</ng-template>

<p-toast />
